<template>
  <div class="space-y-4">
    <div class="flex justify-between">
      <h2 class="font-semibold uppercase text-gray-600">Vehicles</h2>
      <router-link
        to="/vehicles/add"
        class="px-4 py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-700"
      >Add Vehicle</router-link>
    </div>

    <div class="flex justify-between">
      <div class="relative max-w-sm w-full">
        <div class="absolute inset-y-0 flex items-center px-3">
          <i class="material-icons text-gray-500">search</i>
        </div>
        <input @keyup="search" class="rounded border pl-10 pr-4 py-2 w-full" placeholder="Search" />
      </div>
      <div class="w-1/3">
        <select class="form-select w-1/2" v-model="vehicleType" @change="getVehicles">
            <option :selected="vehicleType === 'all'" value="all">
              All
            </option>
            <option
              v-for="type in vehicleTypes"
              :key="type._id"
              :selected="vehicleType === type._id"
              :value="type._id"
            >
              {{ type.name }}
            </option>
        </select>

        <select class="form-select w-1/2" v-model="filter" @change="getVehicles">
            <option :selected="filter === 'all'" value="all">
              All
            </option>
            <option
              :selected="filter === 'active'"
              value="active"
            >
              Active
            </option>
            <option
              :selected="filter === 'online'"
              value="online"
            >
              Online
            </option>
        </select>
      </div>
      
    </div>

    <div class="inline-block min-w-full shadow rounded-lg mt-4">
      <table class="min-w-full leading-normal">
        <thead>
          <tr>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >Model Name</th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >Vehcle Type</th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >Driver Name</th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >License Plate</th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >Status</th>
            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100"></th>
          </tr>
        </thead>
        <tbody class="relative" v-if="vehicles.data && vehicles.data.length">
          <tr v-for="(vehicle, index) in vehicles.data" :key="index">
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <p class="whitespace-no-wrap">{{ vehicle.modelYear }}</p>
              <p class="text-gray-600 whitespace-no-wrap">{{ vehicle.modelName }}</p>
            </td>
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <p class="text-gray-900 whitespace-no-wrap">{{ vehicle.vehicleType.name }}</p>
              <p class="text-gray-600 whitespace-no-wrap">{{ vehicle.vehicleType.numberOfSeats }}</p>
            </td>
            <td
              v-if="vehicle.driver"
              class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
            >{{ vehicle.driver.firstName + " " + vehicle.driver.lastName }}</td>
            <td
              v-else
              class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
            >{{ "driver not linked" }}</td>
            <td
              class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
            >{{ vehicle.plateNumber }}</td>
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <div v-if="vehicle.active" class="w-6 h-6 rounded-full bg-green-500"></div>
              <div v-else class="w-6 h-6 rounded-full bg-gray-500"></div>
            </td>
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right">
              <div @click.stop class="relative inline-block text-left">
                <div>
                  <span class="rounded-md shadow-sm">
                    <button
                      @click="toggleDropdown(index)"
                      type="button"
                      class="inline-flex justify-center w-full rounded-md px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                      aria-haspopup="true"
                      :aria-expanded="openDropdown === index"
                    >
                      <i class="material-icons">more_vert</i>
                    </button>
                  </span>
                </div>
                <transition
                  enter-active-class="transition ease-out duration-100"
                  enter-class="transform opacity-0 scale-95"
                  enter-to-class="transform opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75"
                  leave-class="transform opacity-100 scale-100"
                  leave-to-class="transform opacity-0 scale-95"
                >
                  <div
                    v-if="openDropdown === index"
                    class="origin-top-right absolute right-0 w-56 rounded-md shadow-lg z-10"
                  >
                    <div
                      class="rounded-md bg-white shadow-xs"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <div class="py-1">
                        <router-link
                          :to="`vehicles/${vehicle._id}/edit`"
                          class="flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                          role="menuitem"
                        >
                          <i class="material-icons">edit</i>
                          <span>Edit</span>
                        </router-link>
                      </div>
                      <button
                        @click="toggleActive(vehicle._id)"
                        type="button"
                        class="w-full flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                        role="menuitem"
                      >
                        <i v-if="vehicle.active" class="material-icons">close</i>
                        <i v-else class="material-icons">check</i>
                        <span>
                          {{
                          vehicle.active ? "Make Inactive" : "Make Active"
                          }}
                        </span>
                      </button>
                      <div class="border-t border-gray-300"></div>
                      <div class="py-1">
                        <button
                          @click="openConfirmBox"
                          type="button"
                          class="flex w-full items-center space-x-2 px-4 py-2 text-sm leading-5 text-red-700 hover:bg-red-200 hover:text-red-800 focus:outline-none focus:bg-red-200 focus:text-red-800"
                          role="menuitem"
                        >
                          <i class="material-icons">delete</i>
                          <span>Delete</span>
                          <portal to="modals">
                            <transition
                              enter-active-class="transition ease-out duration-100"
                              enter-class="transform opacity-0 scale-95"
                              enter-to-class="transform opacity-100 scale-100"
                              leave-active-class="transition ease-in duration-75"
                              leave-class="transform opacity-100 scale-100"
                              leave-to-class="transform opacity-0 scale-95"
                            >
                              <div
                                v-if="confirmOpen"
                                @click="closeConfirmBox"
                                class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-25 z-40"
                              >
                                <div
                                  @click.stop
                                  class="bg-white w-full max-w-lg rounded-lg overflow-hidden shadow-lg"
                                >
                                  <div class="bg-gray-100">
                                    <h3 class="px-6 py-4 font-semibold text-gray-600">Confirm Delete</h3>
                                  </div>
                                  <div class="flex items-center space-x-4 px-6 py-6">
                                    <i class="material-icons text-4xl">warning</i>
                                    <div>
                                      <p>
                                        Are you sure you want to delete this
                                        vehicle?
                                      </p>
                                      <p>
                                        <em
                                          class="text-gray-600 text-sm"
                                        >This action can not be undone!</em>
                                      </p>
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="flex items-end justify-between px-6 py-4">
                                    <button
                                      @click="closeConfirmBox"
                                      type="button"
                                      class="px-4 py-2 text-gray-600 hover:text-gray-900"
                                    >Cancel</button>
                                    <button
                                      @click="deleteVehicle(vehicle._id)"
                                      type="button"
                                      :disabled="deleting"
                                      class="flex items-center space-x-2 px-4 py-2 font-semibold border border-transparent rounded shadow-sm"
                                      :class="
                                        deleting
                                          ? 'bg-red-100 text-red-500 cursor-not-allowed'
                                          : 'bg-red-200 text-red-700 hover:text-red-800 hover:border-red-800'
                                      "
                                    >
                                      <i
                                        v-if="deleting"
                                        class="material-icons spin text-red-700"
                                      >sync</i>
                                      <i v-else class="material-icons">delete</i>
                                      <span>Delete</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </transition>
                          </portal>
                        </button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </td>
          </tr>
          <div
            v-if="loading"
            class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
          >
            <i class="material-icons text-6xl spin">sync</i>
            <span class="block invisible">Loading...</span>
          </div>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="bg-white py-4 text-center text-gray-600 font-semibold">
              <div v-if="loading" class="inline-block">
                <i class="material-icons text-6xl spin">sync</i>
                <span class="block invisible">Loading...</span>
              </div>
              <div v-else class="inline-block">
                <i class="material-icons text-6xl">warning</i>
                <span class="block">No vehicles found!</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex justify-between items-end">
      <p class="text-gray-600">
        Showing
        <strong>{{ start }}</strong> to
        <strong>{{ end }}</strong> of
        <strong>{{ paginator.count }}</strong> entries
      </p>
      <div class="flex items-center space-x-4">
        <div>
          Per page:
          <select class="form-select" name="perPage" id="perPage" v-model="perPage" @change="getVehicles">
            <option :selected="perPage === '10'" value="10">10</option>
            <option :selected="perPage === '25'" value="25">25</option>
            <option :selected="perPage === '50'" value="50">50</option>
            <option :selected="perPage === '100'" value="100">100</option>
          </select>
        </div>
        <div class="space-x-2 flex">
            <button
              @click="goToPrev"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_left</i>
            </button>
            <button
              v-for="page in total"
              :key="`pageLink-${page}`"
              type="button"
              class="p-2"
              :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page,
              }"
              :disabled="currentPage === page"
              @click="goToPage(page)"
            >{{ page }}</button>
            <button
              @click="goToNext"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Pagination from "@/mixins/Pagination";

export default {
  mixins: [Pagination],
  data() {
    return {
      vehicles: [],
      vehicleTypes: [],
      openDropdown: false,
      vehicleType: "all",
      filter: "all",
      perPage: 10,
      searchKey: "",
      loading: true,
      confirmOpen: false,
      deleting: false
    };
  },
  created() {
    this.getVehicles();
    this.getVehicleTypes();
  },
  watch: {
    currentPage() {
      this.getVehicles();
    }
  },
  computed: {
    // vehicles() {
    //   return this.results.length ? this.results : this.allVehicles;
    // }
  },
  methods: {
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    },
    getVehicleTypes() {
      this.$http
        .get("vehicleTypes?limit=100")
        .then(response => {
          this.vehicleTypes = response.data.data;
        })
        .catch(err => console.log(err));
    },
    getVehicles() {
      this.loading = true;
      var path = 'vehicles?populate=["vehicleType","driver"]&page=' + this.currentPage + "limit=" + this.perPage;
      if (this.vehicleType && this.vehicleType != "all") {
        path += "&vehicleType=" + this.vehicleType;
      }

      if (this.searchKey) {
        path += "&q=" + this.searchKey;
      }

      if (this.filter && this.filter == 'active') {
        path += "&active=true";
      } else if (this.filter && this.filter == 'online') {
        path += "&online=true";
      }
      this.$http
        .get(path)
        .then(response => {
          this.vehicles = response.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    openConfirmBox() {
      this.confirmOpen = true;
    },
    closeConfirmBox() {
      this.confirmOpen = false;
    },
    deleteVehicle(id) {
      this.deleting = true;
      this.$http
        .delete(`vehicles/${id}`)
        .then(result => {
          window.flash({
            type: "success",
            body: "Vehicle was deleted successfully!"
          });
          this.getVehicles();
          console.log(result);
        })
        .catch(err => {
          window.flash({
            type: "error",
            body: "Failed to delete the vehilce!"
          });
          console.log(err);
        })
        .finally(() => {
          this.deleting = false;
          this.confirmOpen = false;
          this.openDropdown = false;
          this.getVehicles();
        });
    },
    search: _.debounce(function(e) {
      this.searchKey = e.target.value.trim();
      this.getVehicles();
    }, 500),
    toggleActive(id) {
      const currentStatus = this.vehicles.data.find(vehicle => vehicle._id === id)
        .active;
      this.$http
        .patch(`/vehicles/${id}`, {
          active: !currentStatus
        })
        .then(() => {
          window.flash({
            type: "success",
            body: currentStatus
              ? "Vehicle is now Inactive!"
              : "Vehicle is now Active!"
          });
          this.getVehicles();
        })
        .catch(err => {
          window.flash({
            type: "error",
            body: "Failed to update vehicle status!"
          });
          console.log(err);
        })
        .finally(() => (this.openDropdown = false));
    }
  }
};
</script>
